import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const Error = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="Error" {...rest}>
      <path
        d="M22.2611 20.7462H1.73345L11.9972 2.99756L22.2611 20.7462Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <line
        x1="12"
        y1="14"
        x2="12"
        y2="9"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle
        cx="12"
        cy="16.5"
        r="1.5"
        transform="rotate(-180 12 16.5)"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
